import { z } from "zod"

// Version 1 ---------------------

export const DividerElementV1 = z.object({
  id: z.string(),
  name: z.literal("divider"),
})

export type TDividerElementV1 = z.infer<typeof DividerElementV1>

// Latest ---------------------
export const DividerElement = DividerElementV1
export type TDividerElement = TDividerElementV1
